export const removeDuplicates = (array: string[]): string[] => {
  return Array.from(new Set(array));
};
